import PropTypes from 'prop-types';
import uuid from 'uuid';
import {hashHistory} from "react-router";
import $ from "jquery";

import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {getJobIdPreset, getQtCategories, saveQuote} from "../../api/server-api";
import ActionTypes from "../../misc/actionTypes";
import JsonApi from "../../api/jsonApi";
import NavigationRequests from "./navigation/navigationRequests";
import Config, {
  // getCommonVisualizerType,
  IS_LIXIL_UI,
  IS_LOOK_JOURNEY, IS_OFFLINE_MODE,
  IS_QKB_UI
} from "../../config";
import {isNewlyCreatedJob, parseJobIdResponse} from "../../api/parseResponse";
import {getImagePromiseFromLayout} from "../../misc/getCanvasImageFromLayout";
import {createCartList, getParsedLookUrl} from "../look/lookNavigation/lookFunctions";
import {getLocalStorageItem} from "../../misc/storageFunctions";
import {getDefaultPresetByLook, saveQuoteAndShare} from "../look/lookNavigation/lookFunctions2";
import store from "../../store";
import {GROHE_ON_OPEN_ACTION} from "../look/iframeIntegration";
import {addToCart} from "../../actions/actionFunctions";
// import {setContractBlob} from "../../actions/contractsActions";
import {setAllowRouting} from "../../actions/serverFunctions";
import {renderErrorPopup} from "../../api/api-popups";
import {updatePresetRoomLayout} from "../../misc/presetsFunctions";
import {setShopPageLoaded} from "../../actions/shopFunctions";
import {showWizardInsteadOfQT} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {setAssignQuoteOfflineData} from "../../actions/assignPopupFunctions";
import {VISUALIZER_MANAGEMENT_ACTIONS} from "../../misc/constants";
import {parseWizardResponse} from "../../misc/loadVisualizer";
import {LOCAL_STORAGE_KEYS, LOOK_OVERLAYS} from "../look/core/constants";
import {setLookOverlayOpened} from "../../actions/lookFunctions";
import {updateCurrentQuote} from "../../misc/quotesFunctions";
import {getContracts, setContractBlobs, shouldUseContractSigning} from "../popups/contractSign/contractsFunctions";
import {getOfflineReceiptImages} from "../../actions/printFunctions";
import {loadAllAsyncScripts, removeLoadingElements} from "../../loadingLogic";
import {listenToDashboardMessaging} from "./dashboardMessaging";
import {registerServiceWorker} from "../../misc/offlineImagesCache";
import {getAdditionalFeaturesOnScroll} from "../../api/look-api";
import featuresWorker from "../../webWorkers/featuresWorker";
import {getFeaturesPriceTable} from "../../misc/otherPricingLogic/pricingGridFunctions";
import runJobAutoRecalculateWithNewSkusQuantities
  from "../../misc/otherPricingLogic/runJobAutoRecalculateWithNewSkusQuantities";
// import {setUseFeaturesLightRequest} from "../../actions/navigationFunctions";

export default class Visualizer extends NavigationRequests {

  static defaultProps = {
    useMouseHovering: true,
    useTouchZoom: true,
  };

  static propTypes = {
    toggleUserPopup: PropTypes.func,
    cartItems: PropTypes.array,
    useMouseHovering: PropTypes.bool,
    useTouchZoom: PropTypes.bool,
    userIsLoggedIn: PropTypes.bool,
    isPhoneNumberValidated: PropTypes.bool,
    handleToggleFeatureInfo: PropTypes.func,
    jobId: PropTypes.number,
    mobileNav: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.imageCanvas = null;
    this.navBar = null;
    this.loadByTheDefault = null;
    this.needToSaveQuote = false;
    this.state = {
      messageBoxState: {
        visible: false
      },
      canvasId: uuid.v4(),
      lockedView: false,
      activeFeature: null,
      demoPointClicked: false,
      allowRouting: false,
    };
    // if (this.props.visualizersLoaded.includes(this.layout.visualizerType)) {
    //   loaderEnable()
    // }
    if (IS_LIXIL_UI) { // temporary removed because of additional rooms loading
      loaderEnable();
    }
  }

  setSubscribers() {
    $(window).on(ActionTypes.CHANGE_LAYOUT, this.handleRefresh);
    $(window).on(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
    $(window).on(ActionTypes.CANVAS_SCALE_CHANGED, this.canvasScaleChanged);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.bvOpened && !this.props.bvOpened) {
      this.handleRefresh();
      if (IS_QKB_UI && !this.props.visualizerTutorialFinished && this.props.showVisualizerTutorial) {
        this.props.showVisualizerTutorial(true);
      }
    }
    if (!nextProps.showRestorePopup && this.props.showRestorePopup) {
      this.changeMessageBoxState({visible:false});
      try {
        window.localStorage.removeItem(this.layout.localStorageKey);
      } catch (ex) { console.log("localStorage exception", ex); }
    }
    if (IS_QKB_UI && nextProps.initialFlowRoom && (nextProps.initialFlowRoom !== this.props.initialFlowRoom)) {
      this.tryToSetSelectedRoom()
    }
  }

  componentWillUnmount() {
    $(window).off(ActionTypes.CHANGE_LAYOUT, this.handleRefresh);
    $(window).off(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
    $(window).off(ActionTypes.CANVAS_SCALE_CHANGED, this.canvasScaleChanged);
  }

  shouldComponentUpdate() {
    return !window.requestInProcess
  }

  applyStoredItems = async () => {
    loaderEnable();
    this.changeMessageBoxState({visible:false});
    try {
      const bvState = JSON.parse(window.localStorage.getItem(this.layout.localStorageKey));
      await this.layout.setItemsFromBvState(bvState, true);
    } catch (ex) { console.log("applyStoredItems localStorage exception", ex); }
    loaderDisable();
    this.props.updateCanvasCount?.();
  };

  setIframeMessaging = () => {
    if (Config.isVisualizerManagement()) {
      window.addEventListener("message", (event) => {
        if (event.data && (event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.getState
          || event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.checkState)) {
          setTimeout(() => {
            getImagePromiseFromLayout(this.layout)
              .then(response => {
                const bvState = this.layout.getActiveFeaturesAsObject(false, false, true);
                bvState.bv_screen = response;
                // console.log('bvState.bv_screen:', bvState.bv_screen);
                window.parent.postMessage({
                  action: event.data.action,
                  payload: bvState
                }, "*");
              })
          }, 0)
        }
        if (event.data && event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.setState) {
          if ((document.kvConfig.visualizerType === "bvLook")) {
            event.data.bvState = updatePresetRoomLayout(event.data.bvState);
            console.log("applying new state...", event.data.bvState);
          }
          this.layout.setItemsFromBvState(event.data.bvState);
        }
      });
    }

    if (window.parent) {
      window.parent.postMessage({
        action: VISUALIZER_MANAGEMENT_ACTIONS.visualizerIsLoaded,
        payload: {
          jobId: document.kvConfig.jobId,
        }
      }, "*");
    }

    listenToDashboardMessaging();

  };

  canvasScaleChanged = (event, canvas_scale) => {
    if (canvas_scale !== 1) {
      this.setDemoPointClicked();
      $(window).off(ActionTypes.CANVAS_SCALE_CHANGED);
    }
  }

  async setVisualizerInfo(mainResponse, bvGroupsResponse, qtCategories, layoutTypes, userIsLoggedIn, savedTempData) {
    if (Config.isDevMode() || document.kvConfig.kioskMode) {
      console.log('mainResponse-->', mainResponse);
      // if (mainResponse) {
      //   console.log('mainResponse features-->', mainResponse.features);
      // }
      console.log('bvGroupsResponse-->', bvGroupsResponse);
      console.log('savedTempData-->', savedTempData);
    }
    parseWizardResponse(mainResponse, qtCategories, this.layout.visualizerType); // lixil ui enable routing
    featuresWorker.cacheFeatureGroupsResponses(mainResponse, qtCategories, this.layout);
    if (qtCategories.length) {
      this.loadQtCategoriesFeatures(qtCategories); // load features from feature groups
    }
    this.layout.createCustomConfigurations(); // set shower body first
    this.layout.setGroupsItemsCount(bvGroupsResponse);
    // if (bvGroupsResponse && getCommonVisualizerType() === "kitchen") { // removed this logic, download countertops always as usual
      // toggles to request all features at once or each feature separately
      // store.dispatch(setUseFeaturesLightRequest({
      //   countertops: !(bvGroupsResponse["countertop"] && bvGroupsResponse["countertop"].totalFeaturesCount > 8000), //increased for nhance
      //   cabinets: !(bvGroupsResponse["top Cabinet"] && bvGroupsResponse["top Cabinet"].totalFeaturesCount > 6000),
      // }))
    // }
    this.layout.setDefaultFeatures();
    if (qtCategories.length) {
      this.layout.setQtCategoriesSubparts(qtCategories); // set QtCategories subParts(wait until defaults are set)
      this.loadQtCategoriesFeatures(qtCategories); // load features from feature groups second time!!
      // after qtCategories are set (because we need partIdExistInQtCategory logic)
    }

    // 2) check what to set next
    const {lookIdFromUrl} = getParsedLookUrl();

    const presets = mainResponse.defaults || [];
    console.log("presets", presets);

    let loadByTheDefault = null;
    let isCartAndUserStatedUpdateNeeded = false;

    let recoverFromTempId = savedTempData && Array.isArray(savedTempData.records);
    if (recoverFromTempId) {
      console.log("recoverFromTempId savedTempData", savedTempData);
      this.loadByTheDefault = savedTempData.records[0].data;
      this.loadByTheDefault.alreadyRestored = true;
      loadByTheDefault = savedTempData.records[0].data;
      await parseJobIdResponse(savedTempData);
    }
    console.log("userIsLoggedIn", userIsLoggedIn);

    if (!loadByTheDefault) {
      loadByTheDefault = lookIdFromUrl ? getDefaultPresetByLook(presets, lookIdFromUrl) : null;
      console.log("loadByTheDefault by lookIdFromUrl", loadByTheDefault);
      console.log("lookIdFromUrl", lookIdFromUrl);
    }
    if (!loadByTheDefault) {
      loadByTheDefault = presets.find(preset => preset.loadByTheDefault);
      console.log("loadByTheDefault by mainResponse", loadByTheDefault);
    }
    const editJobId = document.kvConfig.jobId && document.kvConfig.jobId > 0;
    console.log('editJobId', editJobId);

    const editToken = store.getState().userState.editToken;
    console.log('editToken', editToken);

    if (editJobId || editToken) {
      //console.log('resetting', document.kvConfig.jobId);
      const jobResponse = await getJobIdPreset(document.kvConfig.jobId, editToken);
      if (jobResponse && jobResponse.data && !jobResponse.data.error) {
        if (Array.isArray(jobResponse.data.records) && jobResponse.data.records.length) {
          this.loadByTheDefault = jobResponse.data.records[0].data;
          if (this.loadByTheDefault && this.loadByTheDefault.bvStateVersion) { // for old quotes we are keeping old create cart list logic
            this.loadByTheDefault.alreadyRestored = true;
          }
        }
        await parseJobIdResponse(jobResponse.data);
        if (loadByTheDefault && isNewlyCreatedJob(jobResponse.data)) {
          await this.setFirstPreset(loadByTheDefault, layoutTypes);
          await updateCurrentQuote(0);
        }
      } else if (loadByTheDefault) {
        await this.setFirstPreset(loadByTheDefault, layoutTypes)
      }
      if (IS_QKB_UI && !document.kvConfig.visualizerOnly
        && (!window.location.href.includes("#/") || !window.location.href.split("#/")[1].length)) {
        if (this.props.fabricatorSettings.checkout) {
          this.goToCart()
        } else {
          this.props.toggleBathroomVisualizerOpen(true);
          if (!window.location.hash.includes("visualizer")) {
            hashHistory.push("visualizer");
          }
        }
      }
      return true
    } else if (loadByTheDefault) {
      if (!recoverFromTempId) { // temp id data is recovered in parse response
        await this.setFirstPreset(loadByTheDefault, layoutTypes, isCartAndUserStatedUpdateNeeded);
      }
      // 3) restore share button or save quote click
      if (loadByTheDefault.returnAction) {
        this.needToSaveQuote = false;
        if (!userIsLoggedIn) {
          console.info(`Sorry, can't share to ${loadByTheDefault.returnAction}, the user is not logged in, so the quote can not be saved.`);
          return
        }
        if (loadByTheDefault.returnAction === GROHE_ON_OPEN_ACTION.saveQuote) {
          setTimeout(() => {$("button[data-id='save-button']").trigger('click')}, 0);
        } else if ([
          GROHE_ON_OPEN_ACTION.shareFacebook,
          GROHE_ON_OPEN_ACTION.sharePinterest,
          GROHE_ON_OPEN_ACTION.shareTwitter].some(action => loadByTheDefault.returnAction === action)) {
          setTimeout(() => {
            const {shareUrl} = store.getState().serverState;
            saveQuoteAndShare(loadByTheDefault.returnAction, shareUrl);
          }, 0);
        }
      }
    }

  }

  setFirstPreset = async (roomPreset, layoutTypes, isCartAndUserStatedUpdateNeeded= false) => {
    if (!layoutTypes || layoutTypes[roomPreset.layout_type]) {
      // this.setNewBvState(roomPreset, true);
      console.log("roomPreset", roomPreset);
      const layout_type = +roomPreset.layout_type;
      const needToChangeLayout = (layout_type || layout_type === 0) && (layout_type !== +this.layout.type);
      if (needToChangeLayout) {
        await this.changeLayout(layout_type, true)
      }
      if (this.props.setFirstLoadedPreset) {
        this.props.setFirstLoadedPreset(roomPreset.id);
      }
      await this.layout.setItemsFromBvState(
        roomPreset, isCartAndUserStatedUpdateNeeded, (bvState) => bvState, true
      )
    }
  }

  getQtCategoriesCommon = () => {
    return (this.props.qtCategoriesRequested && this.props.qtCategoriesRequested.includes(this.layout.visualizerType))
      ? Promise.resolve([])
      : getQtCategories(this.layout.getCurrentLayoutAbbreviation())
  }

  setNewBvState = (bvState, firstLoad = false) => {
    this.layout.initialized = false;
    if (!firstLoad) {
      loaderEnable();
    }
    this.layout.setActiveFeaturesFromObject(bvState, false, false, true, true);
    if (!firstLoad) {
      this.handleRefresh();
      loaderDisable();
    }
  };

  resetEverything = () => {
    this.layout.resetEverything();
    if (this.navBar && this.navBar.resetWizardSteps) {
      this.navBar.resetWizardSteps()
    }
    this.handleRefresh();
  };

  goToCart = () => {
    this.props.toggleBathroomVisualizerOpen(false);
    this.props.setCameFromPage('visualizer');
    if (!window.location.href.includes('shoppingcart')) {
      hashHistory.push('shoppingcart');
    }
  };

  onBvLoad = () => {
    this.props.setCanvasId(this.state.canvasId);
    if (IS_QKB_UI && document.kvConfig.visualizerOnly) {
      this.props.toggleBathroomVisualizerOpen(true);
      if (!window.location.hash.includes("visualizer")) {
        hashHistory.push("visualizer");
      }
    } else {
      const layoutParts = this.layout.getFeatures()
        .filter(parentGroup => parentGroup.categoryEnabled)
        .map((parentGroup) => parentGroup.partName);
      this.props.setLayoutDataParts(layoutParts);
      this.props.setDefaultSelectionGroup(layoutParts[0]);
      $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS);
    }
    if (IS_QKB_UI && !(document.kvConfig.jobId && document.kvConfig.jobId > 0) && !Config.isVisualizerManagement()) {
      this.askToRestore(this.layout.localStorageKey);
    }
  };

  checkShareUrl = async () => {
    let design = new URLSearchParams(window.location.search).get("design");
    if (design && (design[design.length - 1] === "/")) {
      design = design.slice(0, -1);
    }
    if (design) {
      const jobResponse = await getJobIdPreset(design);
      console.log("jobResponse for share URL design #" + design, jobResponse);
      if (jobResponse && jobResponse.data && Array.isArray(jobResponse.data.records) && jobResponse.data.records.length) {
        this.loadByTheDefault = jobResponse.data.records[0].data;
        await parseJobIdResponse(jobResponse.data, true);
      }
    }
  };

  handleRefresh = () => {
    this.forceUpdate();
  };

  renderGreenLayerByZindex = (zIndex) => {
    this.imageCanvas.renderGreenLayerByZindex(zIndex)
  };

  setHoveredLayer = (event) => {
    this.imageCanvas.setHoveredLayer(event)
  };

  setCanvasClass = (canvasClass, removeAllClasses) => {
    if (this.imageCanvas) {
      this.imageCanvas.imageCanvasScroll(canvasClass, removeAllClasses, this.layout.type, this.layout.scene);
    }
  };

  changeMessageBoxState = (newMessageBoxState) => {
    this.setState({
      messageBoxState: {...this.state.messageBoxState, ...newMessageBoxState}
    })
  };

  setActiveFeature = (activeFeature) => { // this is needed for lock screen. we can't get rid of that
    this.setState({
      activeFeature
    })
  };

  setDemoPointClicked = () => {
    this.setState({
      demoPointClicked: true
    })
  };

  loadQtCategoriesFeatures = (qtCategories) => {
    // console.log("featureGroupsWithoutFeatures", featureGroupsWithoutFeatures);
    const {wizardList, wizardIsActive} = store.getState().wizardState;
    const useWizard = showWizardInsteadOfQT(wizardList, wizardIsActive);

    const featureGroupsWithoutFeatures = this.layout.loadFeatureGroupFeatures(qtCategories);
    if (featureGroupsWithoutFeatures.length && !IS_LIXIL_UI && !useWizard) {
      if (this.layout.isNewLayout) {
        const toRequestFeatureGroups = featureGroupsWithoutFeatures.filter(subPart => {
          return !subPart.part.nextFeaturesPageToLoadArray
            || !this.layout.hasNavItemsLength(subPart, {}, "", null, true, [])
        });
        // prevent requesting countertops and backsplashes since the preset is not applied yet!
        Promise.all(toRequestFeatureGroups.map(subPart => {
          return getAdditionalFeaturesOnScroll(subPart.part, true)
        })).then(() => {
          $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS)
        })
      } else featureGroupsWithoutFeatures.forEach(sPart => {
        this.checkIfAllFeaturesReceived(sPart, null, () => {
          $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS);
        }, false)
      })
    }
  };

  finishLoading = async () => {
    store.dispatch(setShopPageLoaded(true)); // lixil ui don't do any requests on the shop page
    store.dispatch(setAllowRouting(true)); // lixil ui enable routing
    await this.getContractSignDocument(); // no need for now, we are keeping existing structure (first save, then - contract)
    await this.getAssignQuoteCustomersAndEmployees(); // no need for now, we are keeping existing structure (first save, then - contract)
    if (IS_OFFLINE_MODE) {
      await loadAllAsyncScripts();
      await registerServiceWorker();
    }
    if (IS_LOOK_JOURNEY) {
      let loadByTheDefault = this.loadByTheDefault && this.loadByTheDefault.id === this.props.activePreset ? this.loadByTheDefault : null
      if (!loadByTheDefault || !loadByTheDefault.alreadyRestored) {
        setTimeout(() => {
          const {qtActiveCategory} = store.getState().qtState;
          const cartItems = createCartList(qtActiveCategory, loadByTheDefault);
          if (cartItems.length) {
            store.dispatch(addToCart(cartItems))
          }
        }, 1000) // is needed to finish render routing first (to create cart list from already selected features)
      }
    }

    if (true) {
      await store.dispatch(getFeaturesPriceTable());
    }

    if (this.props.initialFlowStep === 3) {
      this.changeLayout(this.props.initialFlowRoomLayout);
      this.tryToSetSelectedRoom();
    } else {
      console.log('initialized', this.layout);
      this.layout.initialized = true;
      this.handleRefresh();
      if (!this.props.bvOpened || IS_LIXIL_UI || !this.layout.getLayers().length) {
        loaderDisable();
      }
    }

    removeLoadingElements("Visualizer");

    if (this.props.visualizersLoaded.includes(this.layout.visualizerType)) {
      this.setSubscribers();
      return false
    }
    this.setIframeMessaging();
    this.props.addVisualizersLoaded(this.layout.visualizerType);
    const isDashboardJobResaving = window.location.href.includes("saveOnLoad=true");
    const isDashboardJobAutoRecalculating = window.location.href.includes("isAutoRecalculate=true")
      && window.location.href.includes("skuQuantities=");
    if (this.needToSaveQuote || isDashboardJobResaving) {
      setTimeout(async () => {
        let dashboardAutoRecalculateResult = null;
        if (isDashboardJobResaving && isDashboardJobAutoRecalculating) {
          // here we remove all missing skus, and if quantity is less then cart we should change quantity.
          dashboardAutoRecalculateResult = await runJobAutoRecalculateWithNewSkusQuantities();
        }
        saveQuote({
          submit: true,
          showReceipt: false,
          isDashboardJobAutoRecalculating,
          dashboardAutoRecalculateResult,
        })
          .then((saveJobResponse) => {
            if (this.props.updateCanvasCount) {
              this.props.updateCanvasCount(); // this is fixing the bug on mobile, after return from Grohe Register page the canvas is empty(white)
            }
            if (isDashboardJobResaving && window.parent) {
              window.parent.postMessage({
                action: VISUALIZER_MANAGEMENT_ACTIONS.visualizerIsSaved,
                saveJobResponse,
              }, "*");
            }
          });
      }, 0)
    }
    setTimeout(() => {
      if (!Object.keys(this.layout.allDbFeatures).length) {
        loaderDisable();
        renderErrorPopup("No Features Available");
      }
    }, 1000)
    if (IS_LOOK_JOURNEY && !document.kvConfig.jobId && !Config.isVisualizerManagement() && getLocalStorageItem(this.layout.localStorageKey)) {
      store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.questionRestore));
    } else if (IS_LOOK_JOURNEY && (!document.kvConfig.isBackend || !getLocalStorageItem(LOCAL_STORAGE_KEYS.introVisited))
      && this.layout.isNewLayout && !document.kvConfig.jobId) { // always for client mode
      store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.intro));
    }
    // console.log("Main loading took " + (performance.now() - window.t1) + " milliseconds.");
  };

  getContractSignDocument = async () => {

    const contractsList = await getContracts(); // set empty array to show sign route

    if (IS_OFFLINE_MODE && shouldUseContractSigning(this.props.fabricatorSettings, null, true)) {
      await getOfflineReceiptImages(); // cache images from the receipt
      await setContractBlobs(contractsList, 0, true);
      // const documentResult = await JsonApi.getDocumentForFabricator();
      // if (documentResult && documentResult.data && documentResult.data.base64PDF) {
      //   const responseFetch = await fetch("data:application/pdf;base64," + documentResult.data.base64PDF);
      //   const blob = await responseFetch.blob();
      //   // console.log("responseFetch", blob);
      //   const jobDocumentUrl = URL.createObjectURL(blob);
      //   // console.log("createdBlobDocument", jobDocumentUrl);
      //   store.dispatch(setContractBlob(jobDocumentUrl));
      // }
    }
  }

  getAssignQuoteCustomersAndEmployees = async () => {
    if (IS_OFFLINE_MODE && document.kvConfig.isBackend && !document.kvConfig.visualizerOnly) {
      const custAndEmpResponse = await JsonApi.getCustomersAndEmployees();
      if (custAndEmpResponse && custAndEmpResponse.data && (custAndEmpResponse.data.clients || custAndEmpResponse.data.employees)) {
        store.dispatch(setAssignQuoteOfflineData({
          assignQuoteOfflineCustomers: (custAndEmpResponse.data.clients || []).filter(client => client.fullName && client.email),
          assignQuoteOfflineEmployees: (custAndEmpResponse.data.employees || []).filter(employee => employee.fullName),
        }));
      }
    }
  }

  tryToSetSelectedRoom = () => {
    const roomChosen = store.getState().initialFlowState.initialFlowRoom;
    const {activeQuoteIndex} = store.getState().quotesState;
    if (this.layout.qtCategories && roomChosen) {
      this.layout.qtCategories.forEach((qtCategory => {
        if (qtCategory.subParts) {
          qtCategory.subParts.forEach((subPart) => {
            if (subPart.part.partName === "Room") {
              if (subPart.part.features) {
                const selectedRoomFeature = subPart.part.features.find(feature => feature.partName === roomChosen);
                if (selectedRoomFeature) {
                  subPart.part.activeFeature = selectedRoomFeature;
                  subPart.part.firstClick[activeQuoteIndex] = true;
                }
              }
            }
          })
        }
      }))
    }
  };

  askToRestore = (localStorageKey) => {
    try {
      const bvState = JSON.parse(window.localStorage.getItem(localStorageKey));
      if (bvState) {
        this.changeMessageBoxState({
          visible: true,
          message: "messageBox.restoreSessionTitle",
          buttons: [{
            text: "messageBox.buttonNo",
            color: "blue",
            click: () => {
              this.changeMessageBoxState({visible:false});
              window.localStorage.removeItem(localStorageKey);
            }
          },{
            text: "messageBox.buttonYes",
            color: "green",
            click: this.applyStoredItems
          }]
        });
      }
    } catch (ex) { console.log("localStorage exception", ex); }
  };

  checkToShowTutorial = () => {
    return (this.props.bvOpened || this.props.bvVisited) && this.props.visualizerTutorialIsOpened
      && this.layout.initialized && !this.props.visualizerTutorialFinished && this.props.cookieAccepted
      && !this.state.messageBoxState.visible;
  }

}
